// extracted by mini-css-extract-plugin
export default {"headerGrid":"v5Rj0os61U5uVIb0VLM7"};